var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClosure({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166,0 C184.777681,-3.44940413e-15 200,15.2223185 200,34 L200,166 C200,184.777681 184.777681,200 166,200 L34,200 C15.2223185,200 2.29960275e-15,184.777681 0,166 L0,34 C-2.29960275e-15,15.2223185 15.2223185,3.44940413e-15 34,0 L166,0 Z M82,20 L38,20 C28.0588745,20 20,28.0588745 20,38 L20,162 C20,171.941125 28.0588745,180 38,180 L82,180 C91.9411255,180 100,171.941125 100,162 L100,38 C100,28.0588745 91.9411255,20 82,20 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosure);
export default __webpack_public_path__ + "static/media/closure.7fc1e0d6d20233273b7cdd4db305aa53.svg";
export { ForwardRef as ReactComponent };